export default "__VITE_ASSET__X0SkqDl2__"